export type IdNamnType = {
    id: number;
    namn: string;
};

export type CodeValueType = {
    id: number;
    code: string;
    system?: string | null;
    systemName?: string | null;
    codeSystemVersion?: string | null;
    displayName: string;
    originalText?: string | null;
};

// Vårdenhet
export type OrgUnitType = {
    id: number;
    name: string;
    alias: string;
    hsaid: string;
    hsaid_vg?: string;
    hsaid_ve?: string;
    telecom: string;
    email?: string | null;
    postalCode: string;
    numberOrNameOfHouse?: string | null;
    streetName: string;
    city: string;
    location?: string | null;
    arbetsplatskod: string;
    is_active: boolean;
    vardenhetstyp: string;
    avsandaradress?: string | null;
    orgUnit?: number | null;
    orgUnits_full_atkomst: number[] | null;
    orgUnits_villkorad_atkomst: number[] | null;
    vardenhetstyp_display: string;
};

export type UserType = {
    pk: string;
    username: string;
    first_name: string;
    last_name: string;
    email: string;
    is_active: boolean;
    date_joined: string;
    is_superuser: boolean;
    is_verksamhetsadmin: boolean;
    telephoneNumber: string;
    mobileTelephoneNumber: string;
    hsaid?: string | null;
    personId: string;
    personIdType: string;
    name: string;
};

export type RollType = CodeValueType & { permissions: number[] };

// representerar DetailProfileSerializer från backend
export type ProfileDetail = ProfileBase & {
    roll: RollType;
};

export type ProfileType = ProfileBase & {
    roll?: RollType["id"];
};

type ProfileBase = {
    pk: string;
    id: string;
    user: UserType;
    orgUnit: OrgUnitType;
    is_active: boolean;
    is_active_from?: string | null;
    is_active_to?: string | null;
    created_at?: string | null;
    yrkeskategori?: CodeValueType;
    yrkestitel?: string;
    vardteam?: any[];
    signeringsansvarig?: boolean;
    enhetsadministrator?: boolean;
    kombika?: string | null;
    labbportalid?: string | null;
    specialistkompetens?: string | null;
    telephoneNumber?: string | null;
    mobileTelephoneNumber?: string | null;
    healthCareProviderHsaId: string;
    personalPrescriptionCode?: string | null;
    groupPrescriptionCode?: string | null;
    healthcareProfessionalLicenseIdentityNumber?: string | null;
    user_display: UserType;
    orgUnit_display: OrgUnitType;
    yrkeskategori_display: CodeValueType;

    roll_display: RollType;
    vardteam_display?: any[];
    specialistkompetens_display?: string | null;
    telephoneNumber_display?: string | null;
    mobileTelephoneNumber_display?: string | null;
    full_atkomst_alla_enheter?: boolean;
};

export enum TabColor {
    Default = "default",
    IceBlue = "ice-blue",
}

export enum TabPadding {
    Default = "default",
    None = "none",
}

export type Patient = {
    id: number;
    personId: number;
    personId_formatted: string;
    personIdType: string;
    fornamn: string;
    efternamn: string;
    tilltalsnamn_index: string;
    dateOfBirth: string;
    gender: string;
    adressRad1: string;
    adressRad2: string;
    postnummer: string;
    postort: string;
    coAdress: string;
    telefon: string;
    onskar_sms: boolean;
    email: string;
    sekretess: string;
    skyddad_identitet: boolean;
    patientId: string;
    careCoverage: boolean;
    lan: number;
    created_by: string;
    created_at: string;
    updated_by: string;
    updated_at: string;
    namn: string;
    namn_reverse: string;
    tilltalsnamn: string;
    fornamnslista: string[];
    fullstandigt_namn: string;
    fullstandigt_namn_reverse: string;
    adressRad: string;
    created_by_display: string;
    updated_by_display: string;
    avliden: boolean;
    extra_data: string;
    age: number;
};

export type Avtal = {
    id: number;
    namn: string;
    typ: string;
};

export type AvtalOption = {
    value: Avtal["id"];
    label: string;
    typ: Avtal["typ"];
};
